import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function TimelineTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug p-8" data-testid="resume-live-preview">
      <h1 className="text-2xl font-bold" style={{ color: accent }}>{draft.full_name || "Your Name"}</h1>
      <p className="text-slate-500 text-xs mt-0.5">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
      {draft.target_role && <p className="text-slate-600 text-xs mt-0.5">{draft.target_role}</p>}
      {draft.summary && <p className="text-slate-700 mt-4">{draft.summary}</p>}
      {draft.skills.length > 0 && (
        <div className="mt-4">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Skills</h2>
          <p className="text-slate-700 mt-1">{draft.skills.join(" • ")}</p>
        </div>
      )}
      {draft.experience.length > 0 && (
        <div className="mt-5">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Experience</h2>
          <div className="pl-4 border-l-2" style={{ borderColor: `${accent}50` }}>
            {draft.experience.map((e, i) => (
              <div key={i} className="relative pb-4">
                <span className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full" style={{ backgroundColor: accent }} />
                <p className="text-slate-400 text-[11px] italic">{dateRange(e.start_date, e.end_date, e.current)}</p>
                <p className="font-semibold text-slate-800">{e.title} — {e.company}</p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mt-4">
          <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mt-1"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school} <span className="text-slate-400 italic">({ed.start_date} - {ed.end_date})</span></p>)}
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
